import React from 'react';

import { FiRefreshCw } from 'react-icons/fi';

import { LailaCardBlock } from '../../../../types';
import { ChatCard } from '../../../../components/Chat/kit';
import { InviteDraftCard } from './InviteDraftCard';
import { InviteListCard } from './InviteListCard';
import { MyChecksCard } from './MyChecksCard';
import { StaffInviteCard } from './StaffInviteCard';
import { CardKind } from './kinds';

export interface LailaCardViewProps {
  card: LailaCardBlock;
}

// How each kind of card a tool sends is drawn. A new kind joins here with
// its component; the server's tool decides the kind and its data.
const CARD_VIEWS: Record<CardKind, React.ComponentType<LailaCardViewProps>> = {
  invite_draft: InviteDraftCard,
  invite_list: InviteListCard,
  staff_invite_draft: StaffInviteCard,
  my_checks: MyChecksCard,
};

// One card from Laila's answer. A kind this page doesn't know yet means the
// server is newer than the page, which a refresh fixes.
export const LailaCard = React.memo<LailaCardViewProps>(({ card }) => {
  const View = CARD_VIEWS[card.kind as CardKind];
  if (View) {
    return <View card={card} />;
  }
  return (
    <ChatCard
      label="Card from Laila"
      icon={<FiRefreshCw aria-hidden />}
      iconTone="neutral"
      title="Laila has something to show you"
      subtitle="This page can’t show it yet. Refresh the page to see it."
    />
  );
});
